import { Box, Stack } from "@chakra-ui/react"
import { HTML } from "../../components/HTML"
import { BuyButton } from "./BuyButton"
import assert from "assert-ts"
import { useProduct } from "./useProduct"

export function ProductDescription() {
  const product = useProduct()
  if (product === null) return null
  return (
    <Box
      backgroundColor="var(--background-color)"
      minHeight="50vh"
      onClick={e => {
        assert(
          e.target instanceof Element && e.currentTarget instanceof Element
        )
        if (e.target.tagName === "A" || e.target.tagName === "BUTTON") return
        if (window.scrollY > 0) return
        e.currentTarget.scrollIntoView({ behavior: "smooth" })
      }}
    >
      <Stack
        direction={["column", null, "row"]}
        paddingX="pageMargin"
        paddingTop="0.4rem"
        paddingBottom={8}
        alignItems="flex-start"
        spacing={[4, null, 0]}
      >
        <Stack width={["100%", null, "50%"]} spacing={4}>
          {product.variants.edges.map(({ node: variant }) => (
            <BuyButton
              key={variant.id}
              variant={variant}
              // label={product.variants.edges.length === 1 ? "" : undefined}
            />
          ))}
        </Stack>
        <HTML width={["100%", null, "50%"]}>{product.descriptionHtml}</HTML>
      </Stack>
    </Box>
  )
}
